export default __webpack_public_path__ + "static/100--stacked-area-fbad980ec2e25de640964d8cf078c3dd.png";